import fileManager from './FileManagerApiClient'
import usuario from './UsuarioApiClient'
import cidade from './CidadeApiClient'
import estado from './EstadoApiClient'
import paciente from './PacienteApiClient'
import ficha from './FichaApiClient'
import odontograma from './OdontogramaApiClient'
import relatorios from './RelatoriosApiClient'
import perfil from './PerfilApiClient'
import perfilPermissao from './PerfilPermissaoApiClient'
import perfilUsuario from './PerfilUsuarioApiClient'
import cobranca from './CobrancaApiClient'
import pagamento from './PagamentoApiClient'
import salaEspera from './SalaEsperaApiClient'
import agenda from './AgendaApiClient'
import atendimento from './AtendimentoApiClient'
import configuracao from './ConfiguracaoApiClient'
import inicio from './InicioApiClient'
import servico from './ServicoApiClient'
import servicoAtendimento from './ServicoAtendimentoApiClient'
import servicoOrcamento from './ServicoOrcamentoApiClient'
import orcamento from './OrcamentoApiClient'
import galeria from './GaleriaApiClient'

export default {
    fileManager,
    usuario,
    cidade,
    estado,
    paciente,
    ficha,
    odontograma,
    relatorios,
    perfil,
    perfilPermissao,
    perfilUsuario,
    cobranca,
    pagamento,
    salaEspera,
    agenda,
    atendimento,
    configuracao,
    inicio,
    servico,
    servicoAtendimento,
    servicoOrcamento,
    orcamento,
    galeria
}
